"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tooltip = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _helpers = require("../../helpers");

var _usePosition2 = require("../../utils/usePosition");

var _Box = require("../Box");

var _Text = require("../Text");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * A tooltip
 */
var Tooltip = function Tooltip(_ref) {
  var _children$props, _children$props2, _children$props3, _children$props4, _children$props5;

  var children = _ref.children,
      _content = _ref.content,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "lg" : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 230 : _ref$width,
      _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? "top" : _ref$placement,
      visible = _ref.visible;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      active = _useState2[0],
      setActive = _useState2[1];

  var handleClick = function handleClick() {
    setActive(function (prevActive) {
      return !prevActive;
    });
  };

  var activate = function activate() {
    setActive(true);
  };

  var deactivate = function deactivate() {
    setActive(false);
  };

  var content = typeof _content === "string" ? truncate(_content) : _content;

  var _usePosition = (0, _usePosition2.usePosition)({
    position: placement,
    offset: 10,
    active: visible !== null && visible !== void 0 ? visible : active
  }),
      anchorRef = _usePosition.anchorRef,
      tooltipRef = _usePosition.tooltipRef;

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.cloneElement(children, {
    ref: anchorRef,
    tabIndex: 0,
    onClick: compose(handleClick, (_children$props = children.props) === null || _children$props === void 0 ? void 0 : _children$props.onClick),
    onMouseOver: compose(activate, (_children$props2 = children.props) === null || _children$props2 === void 0 ? void 0 : _children$props2.onMouseOver),
    onMouseOut: compose(deactivate, (_children$props3 = children.props) === null || _children$props3 === void 0 ? void 0 : _children$props3.onMouseOut),
    onFocus: compose(activate, (_children$props4 = children.props) === null || _children$props4 === void 0 ? void 0 : _children$props4.onFocus),
    onBlur: compose(deactivate, (_children$props5 = children.props) === null || _children$props5 === void 0 ? void 0 : _children$props5.onBlur)
  }), /*#__PURE__*/_react.default.createElement(Tip, _extends({
    p: size === "sm" ? 0.5 : 2,
    width: width,
    bg: "white100",
    ref: tooltipRef,
    zIndex: 1
  }, visible ? // If there's a visible prop being passed; use that
  {
    opacity: visible ? 1 : 0
  } : // Otherwise use the active state
  {
    opacity: active ? 1 : 0
  }), /*#__PURE__*/_react.default.createElement(_Text.Text, {
    variant: "xs"
  }, content)));
};

exports.Tooltip = Tooltip;
var Tip = (0, _styledComponents.default)(_Box.Box).withConfig({
  displayName: "Tooltip__Tip",
  componentId: "ymkaxc-0"
})(["position:absolute;z-index:1;transition:opacity 250ms ease-out;text-align:left;box-shadow:", ";cursor:default;pointer-events:none;"], _helpers.DROP_SHADOW);

var truncate = function truncate(tip) {
  var substring = tip.substring(0, 300);

  if (substring !== tip) {
    substring += "…";
  }

  return substring;
};

var compose = function compose(a, b) {
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    a === null || a === void 0 ? void 0 : a.apply(void 0, args);
    b === null || b === void 0 ? void 0 : b.apply(void 0, args);
  };
};
//# sourceMappingURL=Tooltip.js.map